
<div class="col-12 d-flex flex-wrap view-form">
  <ng-container *ngFor="let item of formData; let i = index" >
    <div [ngSwitch]="item?.type" [class]="'div-input ' + item.class" *ngIf="item?.hide != true">
      <label class="col-12 pe-2">
        <b *ngIf="item?.label">{{item?.label}}:</b>
        <ng-container  *ngIf="getValue(item.key) as value">
          <span *ngSwitchDefault>{{value}}</span>
          <span *ngSwitchCase="'date'">{{value}}</span>
          <span *ngSwitchCase="'select'">
            <div *ngIf="getOption(item) as item">
              {{item?.['label']}}
            </div>
          </span>
          <span *ngSwitchCase="'color'"  [style]="{ backgroundColor: value}"></span>
          <span *ngSwitchCase="'datetime-local'">{{value | date: 'fullDate'}}</span>
          <span *ngSwitchCase="'selectIcon'">
            <div *ngIf="getOption(item) as icon">
              <img [src]="'assets/images/svgs/' + icon?.['icon'] + '.svg'" alt="{{icon?.['label']}}"/>
            </div>
          </span>
          <span *ngSwitchCase="'textEditor'">
            <div [innerHTML]="value"></div>
          </span>
					<hr *ngSwitchCase="'hr'"/>
        </ng-container>
      </label>
      
    </div>
    
  </ng-container>
  <hr class="final-line">
  <div class="col-12 d-flex justify-content-end my-4">
    <button class="btn btn-white-1 m-r-xs" type="button" (click)="back()" alt="Voltar">Voltar</button>
  </div>
</div>